/*
 * @Author: Yehon He 1427749162@qq.com
 * @Date: 2025-04-24 23:08:20
 * @LastEditors: Yehon He 1427749162@qq.com
 * @LastEditTime: 2025-04-25 00:43:23
 * @FilePath: \ecloud-web\packages\mall-cook-platform\src\api\schedule\agenda.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '@/utils/request'

// 获取议程列表
export function getAgendaList(params) {
  return request({
    url: '/schedule/agenda/list',
    method: 'get',
    params
  })
}

// 获取单个议程详情
export function getAgendaDetail(params) {
  return request({
    url: '/schedule/agenda/detail',
    method: 'post',
    data: params
  })
}

// 创建议程
export function createAgenda(data) {
  return request({
    url: '/schedule/agenda/add',
    method: 'post',
    data
  })
}

// 更新议程
export function updateAgenda(data) {
  return request({
    url: '/schedule/agenda/edit',
    method: 'post',
    data
  })
}

// 删除议程
export function deleteAgenda(params) {
  return request({
    url: '/schedule/agenda/delete',
    method: 'post',
    data: params
  })
}

// 获取议程的嘉宾列表
export function getAgendaGuests(params) {
  return request({
    url: '/schedule/agenda/guests',
    method: 'get',
    params
  })
}

// 添加嘉宾到议程
export function addGuestToAgenda(data) {
  return request({
    url: '/schedule/agenda/guest/add',
    method: 'post',
    data
  })
}

// 从议程中移除嘉宾
export function removeGuestFromAgenda(data) {
  return request({
    url: '/schedule/agenda/guest/remove',
    method: 'post',
    data
  })
}

// 更新议程中嘉宾信息
export function updateAgendaGuest(data) {
  return request({
    url: '/schedule/agenda/guest/update',
    method: 'post',
    data
  })
}

// 检查议程时间冲突
export function checkAgendaTimeConflict(params) {
  return request({
    url: '/schedule/agenda/check-conflict',
    method: 'get',
    params
  })
}

// 更新议程排序
export function updateAgendaOrder(data) {
  return request({
    url: '/schedule/agenda/updateSort',
    method: 'post',
    data
  })
} 